import $ from 'jquery';
import { uniqBy } from 'lodash';

// liquid tags could have <script> tags. react does not execute these scripts with rendering
// per dangerouslySetInnerHTML for security reasons. scripts inside liquid contents need to
// have a new attribute `data-liquid="true"`:
//
// <script src"..." data-liquid="true"></script>
// <script data-liquid="true">...</script>
//
// scripts with this attribute will be executed correctly after rendering.
// we need a short timeout to be sure, that the liquid contents are rendered.
function executeScriptsFromLiquidTags() {
  const liquidScriptsInterval = setInterval(() => {
    const $liquidTagScript = $('[data-liquid="true"]');

    if ($liquidTagScript.length) {
      clearInterval(liquidScriptsInterval);
      // iterate over all uniq scripts, because we do not want to run same scripts multiple times
      uniqBy($liquidTagScript, 'src').forEach((element) => {
        const scriptSrc = $(element).attr('src'),
              scriptContent = $(element).text();

        if (scriptSrc) {
          // if there is a <script src"..." data-liquid="true"></script> we create a new script
          // element and append it to the body. the initial script element will be removed
          // afterwards.
          const script = document.createElement('script');
          script.src = scriptSrc;
          $(script).appendTo('body');
          $(element).remove();
        } else if (scriptContent) {
          // if there is a <script data-liquid="true">...</script> we execute this script per
          // eval. the initial attribute will be removed from the script afterwards.
          //
          // eval() is a dangerous function, which executes the code it's passed with the
          // privileges of the caller. If you run eval() with a string that could be affected
          // by a malicious party, you may end up running malicious code on the user's machine
          // with the permissions of your webpage / extension. More importantly, third party
          // code can see the scope in which eval() was invoked, which can lead to possible
          // attacks in ways to which the similar Function is not susceptible.
          // --> https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/eval
          window.eval(scriptContent);
          $(element).removeAttr('data-liquid');
        }
      });

      // remove all other initial script elements
      $liquidTagScript.remove();
    }
  }, 1000);

  // clear the interval after 10 seconds anyways
  setTimeout(() => {
    clearInterval(liquidScriptsInterval);
  }, 10000);
}

export { executeScriptsFromLiquidTags };



// WEBPACK FOOTER //
// ./liquidTags.js